/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2021-01-26 11:32:05
 */

import React, { Component } from "react";
import $ from "jquery";
import * as handler from "../components/utils/handler";
import ReactHtmlParser from "react-html-parser";
import { DataService } from "../services/data.service";

const queryString = require("query-string");

class UserDetails extends Component {
  runApp = window["app-config"].runApp;
  phoneNumberPrefix = window["app-config"].phoneNumberPrefix;
  defaultLanguage = window["app-config"].defaultLang;
  userDetailsConfig = window["app-config"].userDetails;
  configCollections = window["app-config"].collections;
  UI = window["app-config"].ui.userDetailsScreen;
  additionalInfoLength = this.userDetailsConfig.additionalInfo.maxLength;
  estimatedWaitTime =
    window["app-config"].applicationProperties.estimatedWaitTime;
  dataService = new DataService();

  state = {
    lang: {},
    phoneNumber: this.phoneNumberPrefix.defaultPhoneNumber,
    documentType: null,
    additionalInfo: undefined,
    estimatedWaitTime: null,
    emailAddress: null,
    confirmedEmailAddress: null,
    isValidConfirmedEmail: false,
    isValidEmail: undefined,
  };

  firstName;
  surName;
  emailAddress;
  confirmedEmailAddress;
  phoneNumber;
  additionalInfo;
  noOfPeople = this.configCollections.numericArray[0];
  isTermsConditonsChecked = false;
  isAssistanceChecked = false;

  isValidEmail = false;
  isValidConfirmEmail = false;
  isValidFirstName = false;
  isValidSurName = false;
  isValidPhoneNumber = false;
  isValidAdditionalInfo = false;

  phoneNumRef = React.createRef();

  componentDidMount() {
    handler.disableCopyPasteInTextField("#email-field");
    handler.disableCopyPasteInTextField("#confirm-email-field");
    this.props.setHeading(null);
    this.setPhoneNumberPrefix();
    this.setLanguage();

    if (this.runApp.toLowerCase() === "samsung") {
      $(".validate-num").on("keypress", function (event) {
        var regex = new RegExp("^[0-9+]");
        var key = String.fromCharCode(
          !event.charCode ? event.which : event.charCode
        );
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
      });
    }
    if (
      this.UI.showEstimatedWaitTime &&
      (this.props.mainState().issueQrTicket ||
        this.props.mainState().issueTicket)
    ) {
      this.getEstimatedWaitTime();
    }

    this.props.hideBtnNext();
  }

  componentDidUpdate(prevProps, prevState) {
    let stateEmail =
      this.state.emailAddress === null
        ? null
        : this.state.emailAddress.toLowerCase();
    let prevStateEmail =
      prevState.emailAddress === null
        ? null
        : prevState.emailAddress.toLowerCase();
    let stateConfirmEmail =
      this.state.confirmedEmailAddress === null
        ? null
        : this.state.confirmedEmailAddress.toLowerCase();
    let prevStateConfirmEmail =
      prevState.confirmedEmailAddress === null
        ? null
        : prevState.confirmedEmailAddress.toLowerCase();

    if (
      stateEmail !== prevStateEmail ||
      stateConfirmEmail !== prevStateConfirmEmail
    ) {
      if (
        stateEmail !== stateConfirmEmail &&
        this.userDetailsConfig.validateConfirmEmail === true
      ) {
        this.setState({ isValidEmail: false });
      } else if (this.isValidEmail === false) {
        this.setState({ isValidEmail: false });
      } else {
        this.setState({ isValidEmail: true });
      }
    }
    console.log("TST VALID: ", this.state.isValidEmail);
    if (
      this.state.isValidEmail === false ||
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory)
    ) {
      this.props.hideBtnNext();
    } else {
      this.props.showBtnNext();
    }
  }

  setPhoneNumberPrefix = () => {
    if (
      localStorage.getItem("lang") === "es" &&
      this.phoneNumberPrefix.spain !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.spain });
    } else if (
      localStorage.getItem("lang") === "ar" &&
      this.phoneNumberPrefix.uae !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.uae });
    } else if (
      localStorage.getItem("lang") === "en" &&
      this.phoneNumberPrefix.uk !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.uk });
    } else if (
      localStorage.getItem("lang") === "ur" &&
      this.phoneNumberPrefix.pakistan !== ""
    ) {
      this.setState({ phoneNumber: this.phoneNumberPrefix.pakistan });
    } else {
      this.setState({ phoneNumber: this.phoneNumberPrefix.defaultPhoneNumber });
    }
  };

  documentNumberValidation = (value) => {
    if (
      (this.additionalInfo !== undefined &&
        this.isValidAdditionalInfo === false) ||
      this.isValidAdditionalInfo === true
    ) {
      if (value === "CE") {
        if (
          !(
            handler.validation.isNumber(this.additionalInfo) &&
            this.additionalInfo.length ===
              this.userDetailsConfig.documentTypeDropdown.CE_LENGTH
          )
        ) {
          this.props.hideBtnNext();
        }
      } else if (value === "DNI") {
        if (
          !(
            handler.validation.isNumber(this.additionalInfo) &&
            this.additionalInfo.length ===
              this.userDetailsConfig.documentTypeDropdown.DNI_LENGTH
          )
        ) {
          this.props.hideBtnNext();
        }
      } else if (
        value === "Passport" &&
        this.additionalInfo.length !==
          this.userDetailsConfig.documentTypeDropdown.PASSPORT_LENGTH
      ) {
        this.props.hideBtnNext();
      }
    }
  };

  setLanguage = () => {
    this.setState({ lang: handler.setTranslations() });
  };

  /**
   * 
   HANDLING CHANGE EVENTS FOR FIELDS
   */

  onFirstNameChange = (e) => {
    var regex = new RegExp("^[a-zA-ZÀ-ÿñáéíóúü ]+$");
    if (
      ((e.target.value.length === 0 && e.target.value === "") ||
        !regex.test(e.target.value)) &&
      this.runApp.toLowerCase() === "samsung"
    ) {
      $("#firstname-field").css("border-color", "red");
      this.isValidFirstName = false;
    } else if (e.target.value.length === 0 && e.target.value === "") {
      $("#firstname-field").css("border-color", "red");
      this.isValidFirstName = false;
    } else {
      this.isValidFirstName = true;
      $("#firstname-field").css("border-color", "#dadada");
      this.firstName = e.target.value;
      this.sendDataToParent();
    }
    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onSurNameChange = (e) => {
    var regex = new RegExp("^[a-zA-ZÀ-ÿñáéíóúü ]+$");
    if (
      ((e.target.value.length === 0 && e.target.value === "") ||
        !regex.test(e.target.value)) &&
      this.runApp.toLowerCase() === "samsung"
    ) {
      $("#surname-field").css("border-color", "red");
      this.isValidSurName = false;
    } else if (e.target.value.length === 0 && e.target.value === "") {
      $("#surname-field").css("border-color", "red");
      this.isValidSurName = false;
    } else {
      this.isValidSurName = true;
      $("#surname-field").css("border-color", "#dadada");
      this.surName = e.target.value;
      this.sendDataToParent();
    }
    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onEmailChange = (e) => {
    this.setState({ emailAddress: e.target.value });

    if (
      !handler.validateEmail(e.target.value) ||
      (e.target.value.length === 0 && e.target.value === "") ||
      /^([\w-\.]+([\w-]+\.)+[\w-]{2,4})?$/.test(e.target.value)
    ) {
      $("#email-field").css("border-color", "red");
      this.isValidEmail = false;
    } else {
      $("#email-field").css("border-color", "#dadada");
      this.emailAddress = e.target.value;
      this.setState({ emailAddress: e.target.value });
      this.sendDataToParent();
      this.isValidEmail = true;
    }

    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    } else {
      this.props.showBtnNext();
    }
  };

  onConfirmEmailChange = (e) => {
    this.setState({ confirmedEmailAddress: e.target.value });

    if (
      !handler.validateEmail(e.target.value) ||
      (e.target.value.length === 0 && e.target.value === "") ||
      /^([\w-\.]+([\w-]+\.)+[\w-]{2,4})?$/.test(e.target.value)
    ) {
      $("#confirm-email-field").css("border-color", "red");
      this.isValidConfirmEmail = false;
      console.log(this.isValidConfirmEmail);
    } else {
      $("#confirm-email-field").css("border-color", "#dadada");
      this.confirmedEmailAddress = e.target.value;
      this.isValidConfirmEmail = true;
    }

    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory)
    ) {
      this.props.hideBtnNext();
    } else {
      this.props.showBtnNext();
    }
  };

  onPhoneChange = (e) => {
    if (
      (e.target.value.length === 0 && e.target.value === "") ||
      e.target.value.length <
        this.userDetailsConfig.phoneNumberField.minLength ||
      /\s/.test(e.target.value) ||
      !e.target.value.charAt(0).includes("+") ||
      !/^[0-9+]+$/.test(e.target.value)
    ) {
      $("#phone-field").css("border-color", "red");
      this.isValidPhoneNumber = false;
    } else {
      this.isValidPhoneNumber = true;
      $("#phone-field").css("border-color", "#dadada");
      this.phoneNumber = this.phoneNumRef.current.value;
      this.sendDataToParent();
    }
    this.setState({ phoneNumber: e.target.value });
    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onAdditionalInfoChange = (e) => {
    console.log(e.target.value);
    this.additionalInfo = e.target.value;
    if (
      this.userDetailsConfig.documentTypeDropdown.enabled &&
      !handler.validation.isNumber(e.target.value) &&
      (this.state.documentType === "CE" ||
        (this.state.documentType === "DNI" &&
          this.state.documentType !== "Passport"))
    ) {
      this.props.hideBtnNext();
    } else {
      if (
        e.target.value === "" &&
        e.target.value.length === 0 &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory
      ) {
        this.isValidAdditionalInfo = false;
        this.props.hideBtnNext();
      } else if (
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.state.documentType.toLowerCase() === "dni" &&
        e.target.value.length !==
          this.userDetailsConfig.documentTypeDropdown.DNI_LENGTH
      ) {
        this.isValidAdditionalInfo = false;
        this.props.hideBtnNext();
      } else if (
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.state.documentType.toLowerCase() === "ce" &&
        e.target.value.length !==
          this.userDetailsConfig.documentTypeDropdown.CE_LENGTH
      ) {
        this.isValidAdditionalInfo = false;
        this.props.hideBtnNext();
      } else if (
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.state.documentType.toLowerCase() === "passport" &&
        e.target.value.length !==
          this.userDetailsConfig.documentTypeDropdown.PASSPORT_LENGTH
      ) {
        this.isValidAdditionalInfo = false;
        this.props.hideBtnNext();
      } else {
        this.isValidAdditionalInfo = true;
        this.sendDataToParent();
      }
    }

    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.additionalInfo === undefined &&
        this.isValidAdditionalInfo === false &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onNoOfPeopleChange = (e) => {
    this.noOfPeople = e.target.value;

    this.sendDataToParent();
    this.documentNumberValidation(this.state.documentType);
    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onDocumentTypeChange = (e) => {
    this.setState({ documentType: e.target.value });
    this.sendDataToParent();

    this.documentNumberValidation(e.target.value);

    if (e.target.value === "CE") {
      this.additionalInfoLength =
        this.userDetailsConfig.documentTypeDropdown.CE_LENGTH;
    } else if (e.target.value === "DNI") {
      this.additionalInfoLength =
        this.userDetailsConfig.documentTypeDropdown.DNI_LENGTH;
    } else if (e.target.value === "Passport") {
      this.additionalInfoLength =
        this.userDetailsConfig.documentTypeDropdown.PASSPORT_LENGTH;
    }

    if (
      (this.isValidSurName === false &&
        this.userDetailsConfig.enableSurnameField === true) ||
      (this.isValidFirstName === false &&
        this.userDetailsConfig.enableFirstNameField === true) ||
      (this.state.isValidEmail === false &&
        this.userDetailsConfig.enableEmailField === true) ||
      // (this.isValidConfirmEmail === false &&
      //   this.userDetailsConfig.validateConfirmEmail === true) ||
      (this.isValidPhoneNumber === false &&
        this.userDetailsConfig.phoneNumberField.enabled === true) ||
      (this.isTermsConditonsChecked === false &&
        this.userDetailsConfig.termsConditionCheckBox.enabled &&
        this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
      (this.isValidAdditionalInfo === false &&
        (this.additionalInfo === undefined || this.additionalInfo === "") &&
        this.userDetailsConfig.additionalInfo.enabled &&
        this.userDetailsConfig.additionalInfo.isMandatory) ||
      (this.documentType === null &&
        this.userDetailsConfig.documentTypeDropdown.enabled &&
        this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
      (this.userDetailsConfig.validateConfirmEmail &&
        this.isValidConfirmEmail === false)
    ) {
      this.props.hideBtnNext();
    }
  };

  onCheckBoxChange = (e) => {
    if (e.target.id === "termsCondition") {
      this.isTermsConditonsChecked = e.target.checked;
      this.sendDataToParent();

      this.documentNumberValidation(this.state.documentType);

      if (
        (this.isValidSurName === false &&
          this.userDetailsConfig.enableSurnameField === true) ||
        (this.isValidFirstName === false &&
          this.userDetailsConfig.enableFirstNameField === true) ||
        (this.state.isValidEmail === false &&
          this.userDetailsConfig.enableEmailField === true) ||
        (this.isValidConfirmEmail === false &&
          this.userDetailsConfig.validateConfirmEmail === true) ||
        (this.isValidPhoneNumber === false &&
          this.userDetailsConfig.phoneNumberField.enabled === true) ||
        (this.isTermsConditonsChecked === false &&
          this.userDetailsConfig.termsConditionCheckBox.enabled &&
          this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
        (this.documentType === null &&
          this.userDetailsConfig.documentTypeDropdown.enabled &&
          this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
        (this.isValidAdditionalInfo === false &&
          (this.additionalInfo === undefined || this.additionalInfo === "") &&
          this.userDetailsConfig.additionalInfo.enabled &&
          this.userDetailsConfig.additionalInfo.isMandatory) ||
        (this.userDetailsConfig.validateConfirmEmail &&
          this.isValidConfirmEmail === false)
      ) {
        this.props.hideBtnNext();
      }
    } else if (e.target.id === "assistance") {
      this.isAssistanceChecked = e.target.checked;
      this.sendDataToParent();
      this.documentNumberValidation(this.state.documentType);
      if (
        (this.isValidSurName === false &&
          this.userDetailsConfig.enableSurnameField === true) ||
        (this.isValidFirstName === false &&
          this.userDetailsConfig.enableFirstNameField === true) ||
        (this.isValidEmail === false &&
          this.userDetailsConfig.enableEmailField === true) ||
        (this.isValidPhoneNumber === false &&
          this.userDetailsConfig.phoneNumberField.enabled === true) ||
        (this.isTermsConditonsChecked === false &&
          this.userDetailsConfig.termsConditionCheckBox.enabled &&
          this.userDetailsConfig.termsConditionCheckBox.isMandatory) ||
        (this.documentType === null &&
          this.userDetailsConfig.documentTypeDropdown.enabled &&
          this.userDetailsConfig.documentTypeDropdown.isMandatory) ||
        (this.isValidAdditionalInfo === false &&
          (this.additionalInfo === undefined || this.additionalInfo === "") &&
          this.userDetailsConfig.additionalInfo.enabled &&
          this.userDetailsConfig.additionalInfo.isMandatory) ||
        (this.userDetailsConfig.validateConfirmEmail &&
          this.isValidConfirmEmail === false)
      ) {
        this.props.hideBtnNext();
      }
    }
  };

  /*
  SENDING DATA TO MAIN
  */

  sendDataToParent = () => {
    this.props.userDetails({
      firstName: this.firstName,
      surName: this.surName,
      emailAddress: this.emailAddress,
      phoneNumber:
        this.userDetailsConfig.phoneNumberField.enabled === true
          ? this.phoneNumRef.current.value
          : null,
      additionalInfo: this.additionalInfo,
      noOfPeople: this.noOfPeople,
      documentType: this.state.documentType,

      isTermsConditonsChecked: this.isTermsConditonsChecked,
      isAssistanceChecked: this.isAssistanceChecked,
      isUserDetailCmp: this.state.isUserDetailCmp,
    });
  };

  getEstimatedWaitTime = async () => {
    try {
      let branchId = this.props.mainState().issueQrTicket
        ? queryString.parse(window.location.search).branchid
        : this.props.branchDetails()[0].BranchID;
      let sqn = this.props.mainState().issueQrTicket
        ? queryString.parse(window.location.search).sqn
        : this.props.mainState().categoryId;

      let response = await this.dataService.getEstimatedWaitTime(
        branchId,
        !this.estimatedWaitTime.branchLevel ? sqn : null
      );

      if (response.data.error !== undefined && response.error === true) {
        this.setState({
          estimatedWaitTime: null,
        });
      } else if (response.data.response_status === 1) {
        this.setState({
          estimatedWaitTime: Math.floor(response.data.est_wait_time / 60),
        });
      } else {
        this.setState({
          estimatedWaitTime: null,
        });
      }
    } catch (error) {
      this.setState({
        estimatedWaitTime: null,
      });
      console.log("ERROR: ", error.message);
    }
  };

  render() {
    return (
      <div className="sl__modal-inner">
        <div className="sl__modal--content">
          <h2 style={{ color: this.UI.headingColor }}>
            {this.props.mainState().issueQrTicket ||
            this.props.mainState().issueTicket
              ? this.state.lang.EnterYourDetailsToConfirmYourTicket
              : this.state.lang.EnterAppointmentDetails}
          </h2>
          {this.state.estimatedWaitTime !== null &&
          this.UI.showEstimatedWaitTime ? (
            <p>
              {this.state.lang.EstimatedWaitTimeMessage} &nbsp;
              <strong>{`${this.state.estimatedWaitTime} ${this.state.lang.Minutes}`}</strong>
              <br />
              <br />
              <br />
            </p>
          ) : null}
          <div className="sl__modal_form-row">
            {this.userDetailsConfig.enableFirstNameField === true ? (
              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.FirstName}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onFirstNameChange}
                  type="text"
                  name="firstname"
                  maxLength={20}
                  placeholder={this.state.lang.FirstNamePlaceholder}
                  id="firstname-field"
                  className="sl__modal_form--input validate-text firstname"
                />
              </div>
            ) : null}

            {this.userDetailsConfig.enableSurnameField === true ? (
              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.SurName}
                  <span
                    className="estaric"
                    style={{
                      color: this.UI.requiredEstaricColor,
                    }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onSurNameChange}
                  type="text"
                  name="surname"
                  maxLength={20}
                  placeholder={this.state.lang.SurNamePlaceholder}
                  id="surname-field"
                  className="sl__modal_form--input validate-text"
                />
              </div>
            ) : null}

            {this.userDetailsConfig.enableNoOfPeopleField === true ? (
              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{
                    color: this.UI.fColor,
                  }}
                >
                  {this.state.lang.NoOfPeople}
                </label>
                <select
                  id="category-selector-sam"
                  className="sl__modal_form--select"
                  defaultValue={this.configCollections.numericArray[0]}
                  onChange={this.onNoOfPeopleChange}
                >
                  <option value={this.configCollections.numericArray[0]}>
                    {this.configCollections.numericArray[0]}
                  </option>

                  {this.configCollections.numericArray.map((data, i) => {
                    return (
                      <option value={data + 1} key={i + 1}>
                        {data + 1}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
          </div>
          <div className="sl__modal_form-row">
            {this.userDetailsConfig.enableEmailField === true ? (
              <div
                className="sl__modal_form-col"
                style={{ color: this.UI.fColor }}
              >
                <label
                  className="sl__modal_form--label"
                  style={{
                    color: this.UI.fColor,
                  }}
                >
                  {this.state.lang.EmailAddress}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onEmailChange}
                  type="email"
                  name="email"
                  placeholder={this.state.lang.EmailAddressPlaceHolder}
                  id="email-field"
                  className="sl__modal_form--input"
                />
              </div>
            ) : null}

            {this.userDetailsConfig.validateConfirmEmail ? (
              <div
                className="sl__modal_form-col"
                style={{ color: this.UI.fColor }}
              >
                <label
                  className="sl__modal_form--label"
                  style={{
                    color: this.UI.fColor,
                  }}
                >
                  {this.state.lang.ConfirmEmailLabel}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onConfirmEmailChange}
                  type="email"
                  name="email"
                  placeholder={this.state.lang.ConfirmEmailPlaceholder}
                  id="confirm-email-field"
                  className="sl__modal_form--input"
                />
              </div>
            ) : null}

            {this.userDetailsConfig.phoneNumberField.enabled === true ? (
              <div
                className="sl__modal_form-col telephone-number"
                style={{ color: this.UI.fColor }}
              >
                <label
                  className="sl__modal_form--label "
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.PhoneNumber}
                  <span
                    className="estaric"
                    style={{ color: this.UI.requiredEstaricColor }}
                  >
                    *
                  </span>
                </label>
                <input
                  onChange={this.onPhoneChange}
                  type="text"
                  name="phone"
                  value={this.state.phoneNumber}
                  placeholder={this.state.lang.PhoneNumberPlaceholder}
                  id="phone-field"
                  maxLength={this.userDetailsConfig.phoneNumberField.maxLength}
                  ref={this.phoneNumRef}
                  className="sl__modal_form--input validate-num"
                />
              </div>
            ) : null}
          </div>
          <div className="sl__modal_form-row">
            {this.userDetailsConfig.documentTypeDropdown.enabled ? (
              <div className="sl__modal_form-col">
                <label
                  className="sl__modal_form--label"
                  style={{
                    color: this.UI.fColor,
                  }}
                >
                  {this.state.lang.DocumentType}
                  {this.userDetailsConfig.documentTypeDropdown.isMandatory ? (
                    <span
                      className="estaric"
                      style={{ color: this.UI.requiredEstaricColor }}
                    >
                      *
                    </span>
                  ) : null}
                </label>
                <select
                  id="document-selector"
                  className="sl__modal_form--select"
                  onChange={this.onDocumentTypeChange}
                  defaultValue={-1}
                >
                  <option value={-1} disabled>
                    {this.state.lang.DocumentTypePlaceholder}
                  </option>
                  {this.configCollections.documentArray.map((data, i) => {
                    return (
                      <option value={data.value} key={data.id}>
                        {data.value}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            {this.userDetailsConfig.additionalInfo.enabled ? (
              <div
                className="sl__modal_form-col additional-info"
                style={{ color: this.UI.fColor }}
              >
                <label
                  className="sl__modal_form--label "
                  style={{ color: this.UI.fColor }}
                >
                  {this.state.lang.AdditionalInformation}
                  {this.userDetailsConfig.additionalInfo.isMandatory ? (
                    <span
                      className="estaric"
                      style={{ color: this.UI.requiredEstaricColor }}
                    >
                      *
                    </span>
                  ) : null}
                </label>
                <textarea
                  onChange={this.onAdditionalInfoChange}
                  rows={this.userDetailsConfig.additionalInfo.rows}
                  cols={this.userDetailsConfig.additionalInfo.columns}
                  placeholder={this.state.lang.AdditionalInformationPlaceholder}
                  className={`sl__modal_form--input`}
                  id="additionalInfo"
                  // maxLength={this.userDetailsConfig.additionalInfo.maxLength}
                  maxLength={this.additionalInfoLength}
                  disabled={
                    this.userDetailsConfig.documentTypeDropdown.enabled &&
                    this.state.documentType === null
                      ? true
                      : false
                  }
                />
              </div>
            ) : null}
            {this.userDetailsConfig.additionalInfo.breakColumn ? (
              <div className="sl__modal_form-col additional-info"></div>
            ) : null}
          </div>
          <div className="sl__modal_form-row">
            {this.userDetailsConfig.termsConditionCheckBox.enabled ? (
              <div
                className="sl__modal_form-col"
                style={{ color: this.UI.fColor }}
              >
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="termsCondition"
                    onChange={this.onCheckBoxChange}
                  />
                  &nbsp;
                  {this.state.lang.termsConditionCheckBox}
                  {this.userDetailsConfig.termsConditionCheckBox.isMandatory ? (
                    <span
                      className="estaric"
                      style={{
                        color: this.UI.requiredEstaricColor,
                      }}
                    >
                      *
                    </span>
                  ) : null}
                </label>
              </div>
            ) : null}

            {this.userDetailsConfig.enableAssistanceCheckBox.enabled ? (
              <div
                className="sl__modal_form-col"
                style={{ color: this.UI.fColor }}
              >
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="assistance"
                    onChange={this.onCheckBoxChange}
                  />
                  &nbsp;
                  {this.state.lang.assistanceCheckBox}
                </label>
              </div>
            ) : null}
          </div>
          <div className="sl__modal_form-row">
            <div className="sl__modal_form-col wide">
              <p className="sl__modal_form-disclaimer">
                {this.runApp.toLowerCase() === "samsung" ||
                this.runApp.toLowerCase() === "others"
                  ? ReactHtmlParser(this.state.lang.AgreementText)
                  : null}
                {/* {ReactHtmlParser(this.state.lang.AgreementText)} */}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UserDetails;
